import { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Button, Stack,
} from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import ResizableDrawer from 'components/Layout/ResizableDrawer';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (data: { name: string }) => Promise<void>;
  item: any;
}

const SkillLevelDrawer: React.FC<Props> = ({ open, onClose, onSave, item }) => {
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setName(item?.name ?? '');
  }, [item, open]);

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      await onSave({ name: name.trim() });
    } finally {
      setSaving(false);
    }
  };

  return (
    <ResizableDrawer open={open} onClose={onClose} defaultWidth={400}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        {item ? intl.get('hr.skill.level.edit') : intl.get('hr.skill.level.add')}
      </Typography>
      <Box component="form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <TextField
          label={intl.get('hr.skill.level.name')}
          value={name}
          onChange={(e) => setName(e.target.value)}
          fullWidth required sx={{ mb: 3 }}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={onClose}>{intl.get('common.cancel')}</Button>
          <Button type="submit" variant="contained" disabled={saving}>
            {intl.get('common.save')}
          </Button>
        </Stack>
      </Box>
    </ResizableDrawer>
  );
};

export default SkillLevelDrawer;
